<template>
	<div v-if="helloBarRotator && !isHidden && !isShowCheckoutHelloBar" class="wc-hello-bar" :class="{'special': helloBarRotator.image}">
		<div class="wc-hello-bar-content" v-html="helloBarRotator.content"></div>
		<span class="hello-bar-close" @click="isHidden = true; setSessionStorage()"></span>
	</div>
</template>

<script setup>
	const config = useAppConfig();
	const rotator = useRotator();

	const helloBar = useState('helloBarCheckout', () => []);
	const helloBarRotator = computed(() => {
		return helloBar.value?.length ? helloBar.value[0] : null;
	})

	const color = ref('#ffffff');
	const background1 = ref('#F57855')
	const background2 = ref('#FE676C')
	const close = ref('#ffffff')
	const closeIcon = ref('#EB4C12')
	const imagePromo = ref('');

	let isShowCheckoutHelloBar = sessionStorage.getItem('isShowCheckoutHelloBar');
	const props = defineProps(['isHidden']);
	function setSessionStorage() {
		sessionStorage.setItem('isShowCheckoutHelloBar', 1);
	}

	onMounted(async () => {
		await fetchData();

		if(helloBar.value?.length) {
			if(helloBar.value[0]?.element_color_1) {
				color.value = helloBar.value[0].element_color_1;
			}
			if(helloBar.value[0]?.element_color_2) {
				close.value = helloBar.value[0].element_color_2;
			}
			if(helloBar.value[0]?.element_color_3) {
				closeIcon.value = helloBar.value[0].element_color_3;
			}
			if(helloBar.value[0]?.element_color_4) {
				background1.value = helloBar.value[0].element_color_4;
			}
			if(helloBar.value[0]?.element_color_5) {
				background2.value = helloBar.value[0].element_color_5;
			}
			if(helloBar.value[0]?.image) {
				imagePromo.value = 'url(' + config.host + helloBarRotator.image_upload_path + ')';
			}
		}
	})

	async function fetchData() {
		if(helloBar.value.length) return;
		const res = await rotator.fetch({code: 'hello_bar_checkout'});
		helloBar.value = res.data?.[0]?.items?.length ? res.data[0].items : [];
	}
</script>

<style lang="less" scoped>
	.wc-hello-bar{
		display: flex; align-items: center; justify-content: space-between; min-height: 60px; margin-top: 30px; padding: 20px 80px 20px 30px; background: linear-gradient(270deg, v-bind(background1) 0%, v-bind(background2) 100%); position: relative;
		&.special{
			min-height: 80px; padding-right: 300px;
			&:before{.pseudo(200px,70px); background: v-bind(imagePromo) no-repeat; background-size: contain; background-position: right bottom; position: absolute; bottom: 0; right: 70px; z-index: 1;}
		}

		@media (max-width: @m){
			margin: 0 -15px; padding: 15px 60px 15px 15px;
			&.special{
				min-height: 60px; padding-right: 200px;
				&:before{.pseudo(125px,50px); right: 10px;}
			}
		}
	}
	.wc-hello-bar-content{
		font-size: 15px; line-height: 1.4; color: v-bind(color); font-weight: 600;
		@media (max-width: @m){font-size: 13px;}
		:deep(p){padding-bottom: 0;}
		:deep(a){
			color: v-bind(color); text-underline-offset: 1px;
			&:hover{color: v-bind(color); text-decoration: none;}
		}
	}
	.hello-bar-close{
		display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; background: v-bind(close); border-radius: 100%; position: absolute; right: 30px; cursor: pointer; z-index: 1; .transition(opacity);
		&:before{
			.icon-x(); font: 16px/16px @fonti; color: v-bind(closeIcon); position: absolute;
			@media (max-width: @m){font-size: 14px;}
		}
		@media (min-width: @t){
			&:hover{opacity: 0.93;}
		}

		@media (max-width: @l){right: 15px;}
		@media (max-width: @t){
			width: 24px; height: 24px; right: 12px;
			&:before {font-size: 10px; line-height: 10px;}
		}
	}
</style>
